import { render } from "./ModalKakou.vue?vue&type=template&id=1cc22c79"
import script from "./ModalKakou.vue?vue&type=script&lang=js"
export * from "./ModalKakou.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__